// extracted by mini-css-extract-plugin
module.exports = {"navlink":"nav-module--navlink--1rIEW","active":"nav-module--active--2hEen"};